function lastSavedStateFormatter(lastSavedState: number): number {
    const TOTAL_STEPS = 7;
    const PERCENT_PER_STEP = 100 / TOTAL_STEPS;

    // Since this is only for incomplete deposits,
    // we only display for steps 1-6. clamp the input
    const clampedStep = Math.max(1, Math.min(6, lastSavedState));

    return Math.round(clampedStep * PERCENT_PER_STEP);
}

export default lastSavedStateFormatter;
